<template>
  <div class="connections-switch-view d-flex justify-end mb-4">
    <v-btn
      :color="active === 'table' ? 'primary' : ''"
      small
      class="mr-3"
      @click.prevent="$router.push({ name: 'system-kafka-import-monitor' })"
    >
      <v-icon>format_list_bulleted</v-icon>
    </v-btn>
    <v-btn
      :color="active === 'chart' ? 'primary' : ''"
      small
      @click.prevent="$router.push({ name: 'system-kafka-import-monitor-chart' })"
    >
      <v-icon>insert_chart_outlined</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.connections-switch-view {
}
</style>
